import { render, staticRenderFns } from "./menu-item-text.vue?vue&type=template&id=f71d487c"
import script from "./menu-item-text.vue?vue&type=script&lang=js"
export * from "./menu-item-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f71d487c')) {
      api.createRecord('f71d487c', component.options)
    } else {
      api.reload('f71d487c', component.options)
    }
    module.hot.accept("./menu-item-text.vue?vue&type=template&id=f71d487c", function () {
      api.rerender('f71d487c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/partials/menu-item-text.vue"
export default component.exports